import { render, staticRenderFns } from "./OtherSwiper.vue?vue&type=template&id=baa1dbec&scoped=true"
import script from "./OtherSwiper.vue?vue&type=script&lang=js"
export * from "./OtherSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa1dbec",
  null
  
)

export default component.exports